import React from 'react';

import cx from 'classnames';

import MapBlock from 'components/shared/MapBlock';

import s from './index.module.css';
import { ILocationBlockProps } from './types';

function LocationBlock({ data: blockData }: ILocationBlockProps) {
  const coords = {
    lat: blockData.data.latitude,
    lng: blockData.data.longitude,
  };
  return (
    <div className={cx(s.wrapper, 'custom-location-wrapper')}>
      <MapBlock containerStyle={{ width: '100%', height: '28rem' }} coords={coords} />
    </div>
  );
}

export default LocationBlock;
